module.exports = __webpack_public_path__ + "img/tips5.9d516777.png";